import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Microsoft Clarity initialization (production only)
const clarityId = import.meta.env.VITE_CLARITY_ID
if (import.meta.env.PROD && clarityId) {
  // Initialize Clarity using the official snippet format
  // Wait for DOM to ensure head exists
  const initClarity = () => {
    if (typeof window.clarity !== 'undefined') return // Already initialized
    
    // Official Microsoft Clarity initialization snippet
    ;(function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments) }
      t = l.getElementsByTagName(r)[0]
      y = l.createElement(r)
      y.async = 1
      y.src = 'https://www.clarity.ms/tag/' + i
      t.parentNode.insertBefore(y, t)
    })(window, document, 'clarity', 'script', clarityId)
  }

  if (document.head) {
    initClarity()
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClarity)
  } else {
    // Fallback: use setTimeout if head isn't ready
    setTimeout(initClarity, 0)
  }
}

// Meta Pixel initialization (production only)
const metaPixelId = import.meta.env.VITE_META_PIXEL_ID
if (import.meta.env.PROD && metaPixelId) {
  const initMetaPixel = () => {
    if (typeof window.fbq !== 'undefined') return // Already initialized
    
    // Meta Pixel base code
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    
    // Initialize pixel with ID
    window.fbq('init', metaPixelId);
    window.fbq('track', 'PageView');
  }

  if (document.head) {
    initMetaPixel()
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetaPixel)
  } else {
    // Fallback: use setTimeout if head isn't ready
    setTimeout(initMetaPixel, 0)
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
